export enum UnauthorizedResponseReason {
   unknown = 'Unknown',
   notAllowed = 'NotAllowed',
   noPermission = 'NoPermission',
   unsupportedAccount = 'UnsupportedAccount',
   emailUnverified = 'EmailUnverified',
   alreadyExists = 'AlreadyExists',
   notAllowedProvider = 'NotAllowedProvider'
}